// extracted by mini-css-extract-plugin
module.exports = {"videoWrap":"media_videoWrap__LzWZs","left":"media_left__514iO","right":"media_right__wo_dm"};